import { api, formatApiError } from "./api";
import { toast } from "sonner";

async function _download(endpoint, filename, mime) {
  try {
    const res = await api.get(endpoint, { responseType: "blob" });
    const blob = new Blob([res.data], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success("Downloaded " + filename);
  } catch (err) {
    toast.error(formatApiError(err));
  }
}

export function downloadCsv(endpoint, filename) {
  return _download(endpoint, filename, "text/csv");
}

export function downloadPdf(endpoint, filename) {
  return _download(endpoint, filename, "application/pdf");
}
